"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArgEnum = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const use_t_1 = require("use-t");
const ContextItem_1 = require("../../ContextItem");
const ToolbarItem_1 = require("../../../Toolbar/ToolbarItem");
const OptionalBadge_1 = require("./OptionalBadge");
const DefaultableToggle_1 = require("./DefaultableToggle");
const AutoValue_1 = require("./AutoValue");
const readStructured = (v) => {
    if (v && typeof v === 'object' && 'def' in v) {
        const s = v;
        return { def: !!s.def, value: String(s.value ?? '') };
    }
    return { def: false, value: typeof v === 'string' ? v : '' };
};
const ArgEnum = ({ param, value, onChange }) => {
    const [t] = (0, use_t_1.useT)();
    const label = param.display?.() ?? t(param.name ?? param.id ?? '');
    const options = param.options ?? [];
    const defaultable = !!param.defaultable;
    const s = readStructured(value);
    const def = defaultable && s.def;
    const emit = (next) => {
        if (defaultable)
            onChange?.(next);
        else
            onChange?.(next.value);
    };
    const setValue = (id) => emit({ def: false, value: id });
    const enterCustom = () => emit({ def: false, value: s.value });
    const revertToAuto = () => emit({ def: true, value: s.value });
    const defaultId = param.default ?? '';
    const toolbar = (React.createElement("span", { style: { display: 'inline-flex', alignItems: 'center', gap: 2 } }, options.map((opt) => {
        const id = opt.id ?? opt.name ?? '';
        const isSelected = id === s.value;
        return (React.createElement(ToolbarItem_1.ToolbarItem, { key: id, small: true, fill: true, selected: isSelected, tooltip: { renderTooltip: () => t(opt.name ?? id) }, onClick: () => setValue(id) }, opt.icon?.()));
    })));
    const autoSelected = options.find((o) => (o.id ?? o.name) === defaultId);
    const autoLabel = autoSelected ? (autoSelected.display?.() ?? t(autoSelected.name ?? defaultId)) : '—';
    const right = defaultable ? (def ? (React.createElement("span", { style: { display: 'inline-flex', alignItems: 'center', gap: 6, marginRight: -4 } },
        React.createElement(DefaultableToggle_1.DefaultableToggle, { def: true, onClick: enterCustom }),
        React.createElement(AutoValue_1.AutoValue, { onClick: enterCustom },
            React.createElement("span", null, autoLabel),
            autoSelected?.icon ? (React.createElement("span", { style: { display: 'inline-flex', marginInlineStart: 6 } }, autoSelected.icon())) : null))) : (React.createElement("span", { style: { display: 'inline-flex', alignItems: 'center', gap: 4, margin: '-5px -8px -5px 0' } },
        React.createElement(DefaultableToggle_1.DefaultableToggle, { def: false, onClick: revertToAuto }),
        toolbar))) : (React.createElement("span", { style: { display: 'inline-flex', alignItems: 'center', gap: 2, margin: '-5px -8px -5px 0' } }, toolbar));
    return (React.createElement(ContextItem_1.ContextItem, { icon: param.icon?.(), control: true, compact: true, inset: true, style: { paddingTop: 6, paddingBottom: 6 }, right: right },
        React.createElement("span", null,
            label,
            param.optional && React.createElement(OptionalBadge_1.OptionalBadge, null))));
};
exports.ArgEnum = ArgEnum;
